<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="fmh" id="_idParaDest-2"><a id="_idTextAnchor001"></a><a href="#/text/9780062653710_Contents#r_idParaDest-2"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii">EPIGRAPH</span></a></h2>
<p class="epi">The Sorceress saw a silvery shadow rise from the Alchemist’s broken body, and dart away across the earth, too fast to chase after. Within the silver, something glowed dark red and pulsing. Too late, the Sorceress realized that the Alchemist had indeed tricked her—he had stolen her heart.</p>
<p class="epi1">—From <i>Sempera’s Classical Histories, the Myth of the Alchemist and the Sorceress</i></p>
<p class="epi">But what if the Alchemist did not die, not really—what if she had found a way to live?</p>
<p class="epi">—From the personal notebooks of Liam Gerling</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062653710_Epigraph.vue?6077feb9